/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Listener, SignalType } from './Types';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _listeners: Record<SignalType, Array<Listener<unknown>>> = {
    ActorAdd: [],
    ActorRemove: [],
    SpriteAdd: [],
    SpriteRemove: [],
};

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function SignalAddListener<T>(type: SignalType, callback: (signal: T) => void): void
{
    _listeners[type].push({ callback });
}

/**
 * @return {void}
 */
export function SignalDispatch<T>(type: SignalType, signal?: T): void
{
    for (const listener of _listeners[type]) {
        listener.callback(signal);
    }
}
